<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import {
		handleSubmit,
		shuffle,
		parseFormdata,
		parseLucid,
		parseMturk,
		getExpParams,
		writeForm,
	} from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	import { getContext } from "svelte";
	import End from "../modals/End.svelte";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute = location.protocol + "//" + location.host;

	let expParams = getExpParams();
	const redirectURL = decodeURIComponent(expParams["redirect-url"]);

	// determine time spent on yourfeed
	let currentTime = +new Date();
	let timeTaken = currentTime - localStorage.getItem("startTime");
	timeTaken = Math.round(timeTaken / (1000 * 60)); // minutes
	timeTaken = ""; // disable automatic calculation

	const { open, close } = getContext("simple-modal");
	const showEndMessage = (
		text,
		showReturnHomeButton,
		isURL,
		isCompletionCode
	) => {
		open(
			End,
			{
				text: text,
				showReturnHomeButton: showReturnHomeButton,
				isURL: isURL,
				isCompletionCode: isCompletionCode,
				onClose: close,
				redirectRoute: redirectRoute,
			},
			{
				closeButton: false,
				closeOnOuterClick: false,
				styleBg: { "background-color": "grey" },
			},
			{}
		);
	};

	const form = useForm();

	const handleClick = () => {
		let completeText;
		let showReturnHomeButton = false;
		let isURL = false;
		let isCompletionCode = false;

		const responses = parseFormdata($form);
		console.log(responses);
		handleSubmit($api_writeForm, responses);

		console.log("checkpoint");
		writeForm($api_writeForm, {
			checkpoint: "end-redirect",
		});

		// for debugging
		// expParams.experiment_id = 'sdfd';
		// expParams.platform = 'prolific';
		if (
			expParams.experiment_id === "solarflare" ||
			localStorage.getItem("experiment_id") === "solarflare"
		) {
			completeText = "";
			showReturnHomeButton = true;
			console.log("Show return home button");
		} else {
			showReturnHomeButton = false;
			console.log("platform:", expParams.platform);
			if (expParams.platform === "lucid") {
				completeText = parseLucid(redirectURL);
				isURL = true;
			} else if (expParams.platform === "mturk") {
				completeText = parseMturk();
				isCompletionCode = true;
			} else if (expParams.platform === "prolific") {
				completeText = redirectURL;
				isURL = true;
			} else {
				showReturnHomeButton = true;
			}
			console.log("completeText:", completeText);
		}

		console.log("Remove condition and experiment_id in localStorage");
		localStorage.removeItem("condition");
		localStorage.removeItem("experiment_id");
		localStorage.removeItem("experiment_parameters");
		localStorage.removeItem("queryParams");
		localStorage.removeItem("redirectionRoutes");
		localStorage.removeItem("nextRoute");
		localStorage.setItem("complete", 1);

		showEndMessage(
			completeText,
			showReturnHomeButton,
			isURL,
			isCompletionCode
		);
	};

	let fields = [
		{
			labelName: "random",
			label: "Did you respond randomly at any point during the study? (Note: Please be honest! If you're taking part in a paid study, you will be paid for your time regardless of your response.)",
			options: shuffle([
				{
					type: "radio",
					value: "no", // value/response to send to server
					option: "No", // what to display
					validate: [required],
				},
				{
					type: "radio",
					value: "yes",
					option: "Yes",
					validate: [required],
				},
			]),
		},
		{
			labelName: "study-duration",
			label: "Roughly how many <strong>minutes</strong> did this study take for you to complete? If an estimate has been provided, feel free to modify it.",
			options: [
				{
					type: "input",
					value: timeTaken,
					option: "",
					validate: [required],
				},
			],
		},
		{
			labelName: "comments",
			label: "Do you have any comments?",
			options: [
				{
					type: "input",
					value: "",
					option: "",
					validate: [],
				},
			],
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>Final questions</h1>

	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={option.validate}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Finish</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 8px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1150px) {
		.option-group {
			display: block;
		}
	}
</style>
